/**
 * Custom icon registrations for missing Fluent UI icons
 * 
 * This module registers icons at import time (before any components load).
 * Only registers icons that Fluent UI doesn't provide by default.
 */
import { registerIcons, initializeIcons } from '@fluentui/react';

// Initialize Fluent UI icons first
initializeIcons("https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/");

// Only define icons that Fluent UI does NOT provide
// These are the ones that showed "icon was used but not registered" warnings
// DO NOT call getIcon() to check - it triggers the same warning!
const customIcons: Record<string, string> = {
  // PascalCase versions
  Report: '\uE9D9',        // Document icon as fallback
  TrendingUp: '\uE110',    // Up chevron
  TrendingDown: '\uE011',  // Down chevron  
  PriorityHigh: '\uE783',  // Important icon
  Risk: '\uE7BA',          // Warning icon
  Leaf: '\uE8BE',          // Leaf/nature icon
  ArrowClockwise: '\uE72C', // Refresh/sync icon
  WorkFlow: '\uE9D7',      // Process icon
  SpeedHigh: '\uEA39',     // Performance icon
  DocumentEdit: '\uE70F',  // Edit document icon
  
  // lowercase versions (some components use lowercase)
  report: '\uE9D9',
  trendingup: '\uE110',
  trendingdown: '\uE011',
  priorityhigh: '\uE783',
  risk: '\uE7BA',
  leaf: '\uE8BE',
  arrowclockwise: '\uE72C',
  workflow: '\uE9D7',
  speedhigh: '\uEA39',
  documentedit: '\uE70F'
};

// Register all custom icons directly - these are NOT in Fluent UI's default set
registerIcons({
  icons: customIcons
});

// Empty function for backward compatibility (icons already registered above)
export function registerCustomIcons() {
  // Icons are registered at module load time, nothing to do here
}

// Function to normalize icon names to PascalCase
export function normalizeIconName(iconName: string): string {
  const iconNameMap: Record<string, string> = {
    'report': 'Report',
    'trendingup': 'TrendingUp',
    'trendingdown': 'TrendingDown',
    'priorityhigh': 'PriorityHigh',
    'risk': 'Risk',
    'workflow': 'WorkFlow',
    'robot': 'Robot',
    'money': 'Money',
    'download': 'Download',
    'export': 'Export',
    'send': 'Send'
  };
  
  return iconNameMap[iconName.toLowerCase()] || iconName;
}

// Map of icon name fixes (original -> correct) - kept for backward compatibility
export const iconNameMap: Record<string, string> = {
  'report': 'Report',
  'trendingup': 'TrendingUp',
  'trendingdown': 'TrendingDown',
  'priorityhigh': 'PriorityHigh',
  'risk': 'Risk',
  'workflow': 'WorkFlow',
  'robot': 'Robot',
  'money': 'Money',
  'download': 'Download',
  'export': 'Export',
  'send': 'Send'
};
